/** Only a trusted auth app_metadata binding marks rewards enrollment complete. */
export function needsSocialRegistration(user: {
  app_metadata?: { provider?: string; providers?: string[]; alpine_iq_id?: unknown };
  identities?: Array<{ provider?: string }>;
}): boolean {
  const metadata = user.app_metadata || {};
  const providers = [
    metadata.provider,
    ...(metadata.providers || []),
    ...(user.identities || []).map((identity) => identity.provider),
  ];
  const social = providers.some((provider) => provider === 'google' || provider === 'apple');
  const alpine = String(metadata.alpine_iq_id ?? '').trim();
  return social && (!alpine || ['0', 'null', 'undefined'].includes(alpine.toLowerCase()));
}
